import type { Item, ArticleImageType } from '../../types';

export const isArticleImage = (item: Item): item is ArticleImageType => {
	return !!(item && item.__typename === 'Article_Image');
};
